import React from 'react'
import DefaultForm from '../../../../../ui/forms/default-form'
import { hasAvailableAction } from '../../../../../ui/gov-actions'
import { RemoveDraftEnrolmentFields, RemoveDraftEnrolmentDone } from "./fields";

const actionValue = 'remove_draft_enrolment'
const actionLabel = 'Remove Draft Enrolment'

const available = record => hasAvailableAction(record, actionValue)

const formEndPoint = ({ gov_id }) =>
  process.env.REACT_APP_API_HOST + `/api/ccs-enrolments/children/${gov_id}/remove-draft`

const actionForm = ({ record }) => ({ handleSuccess }) => (
  <DefaultForm
    url={formEndPoint(record)}
    value={actionValue}
    label={actionLabel}
    loadingTitle="Removing Draft Enrolment"
    formComponent={RemoveDraftEnrolmentFields}
    handleSuccess={payload =>
      handleSuccess(
        {
          [actionValue]: <RemoveDraftEnrolmentDone errors={payload.errors} />,
        },
        actionValue
      )
    }
  />
)

export const removeDraftEnrolment = ({ record, refresh_enrolments }) =>
  available(record)
    ? {
      label: actionLabel,
      value: actionValue,
      onComplete: refresh_enrolments,
      actionForm: actionForm({ record }),
    }
    : null



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/remove-draft-enrolment/index.js